import _ from 'lodash'

import { RECUPERADOR_OPCOES_AUDITOR } from '../actions/itensActions'
import {
  DESCARTAR_VISAO_E_ITENS_POR_VISAO,
  ITENS_POR_VISAO_RECUPERADOS,
  VISAO_POR_AUDITOR_RECUPERADA,
  VISAO_RECUPERADA_ATUALIZADA
} from '../actions/itensPorVisaoActions'
import {
  ALERTA_COMUNICACAO_ATUALIZADA_RECUPERADA,
  ALERTA_COMUNICACAO_PROCESSUAL_CRIADA,
  ALERTA_DOCUMENTO_ATUALIZADO_RECUPERADO,
  ALERTA_PROCESSO_ADM_ATUALIZADO_RECUPERADO,
  ALERTA_PROCESSO_ATUALIZADO_RECUPERADO
} from '../actions/alertasActions'
import { USER_LOGOUT } from '../actions/authenticationJwtActions'
import { extrairVisaoPorAuditor } from '../controllers/itensController'

export const INITIAL_STATE = {}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VISAO_POR_AUDITOR_RECUPERADA:
      return { ...state, ...extrairVisaoPorAuditor(action.payload) }
    case ITENS_POR_VISAO_RECUPERADOS:
      return {
        ...state,
        processosPorVisao: {
          processos: action.payload.second,
          totalProcessos: action.payload.first,
          semProcessos: !_.size(action.payload.second)
        }
      }
    case RECUPERADOR_OPCOES_AUDITOR:
      return { ...state, opcoesAuditor: action.payload ? action.payload : [] }
    case ALERTA_PROCESSO_ATUALIZADO_RECUPERADO: {
      return {
        ...state,
        visaoAtualizada: false
      }
    }
    case ALERTA_COMUNICACAO_PROCESSUAL_CRIADA: {
      return { ...state, visaoAtualizada: false }
    }
    case ALERTA_DOCUMENTO_ATUALIZADO_RECUPERADO: {
      return { ...state, visaoAtualizada: false }
    }
    case ALERTA_COMUNICACAO_ATUALIZADA_RECUPERADA: {
      return { ...state, visaoAtualizada: false }
    }
    case ALERTA_PROCESSO_ADM_ATUALIZADO_RECUPERADO: {
      return { ...state, visaoAtualizada: false }
    }
    case VISAO_RECUPERADA_ATUALIZADA: {
      return {
        ...state,
        visaoAtualizada: true
      }
    }
    case DESCARTAR_VISAO_E_ITENS_POR_VISAO:
      return { ...state, visao: undefined, processosPorVisao: undefined }
    case USER_LOGOUT:
      return INITIAL_STATE
    default:
      return state
  }
}
